import { call, put, select } from 'redux-saga/effects'

import { fetchApi } from '../helpers/fetchApi'
import Logger from '../../helpers/Logger'
import {
  fetchExtraDataSuccess,
  fetchExtraDataFailure
} from '../../actionCreators/essentialExtras/essentialExtrasActionCreators'

const logger = Logger.getInstance()
const apiVersion = 'application/vnd.argos-product.v2+json'
const endpoint = '/product-api/pdp-service/partNumber'
const calculateBasketEndpoint = '/product-api/calculate-basket-price'

const getPrice = data => {
  const price = data.included.filter(included => included.type === 'prices')
  return price[0].attributes
}

const checkForSpecialOffer = (id, offers = []) =>
  offers.find(({ attributes }) => attributes?.productSets?.some(({ products }) => products.includes(id)))

const decodeHTMLEntities = text => {
  const textArea = document.createElement('textarea')
  textArea.innerHTML = text
  return textArea.value
}

function* essentialExtrasDataSaga(action, baseUrl) {
  let variants = []
  const { partNumber, mainProductPartNumber } = action.payload

  try {
    const url = `${baseUrl || ''}${endpoint}/${partNumber}`
    const headers = { Accept: apiVersion }
    const jsonData = yield call(fetchApi, url, null, headers)

    const isTu = jsonData.data.id.startsWith('tuc')

    if (isTu) {
      if (jsonData?.included !== undefined) {
        variants = jsonData.included.find(included => included.type === 'variants')
      }
    }

    const data = {
      name: jsonData.data.attributes.name,
      price: getPrice(jsonData),
      variants: variants || []
    }
    const offers = yield select(state => state.productStore.data.offers)
    const specialOffer = checkForSpecialOffer(partNumber, offers)
    if (specialOffer) {
      const queryData = encodeURIComponent(
        JSON.stringify({
          items: [
            { sku: mainProductPartNumber, quantity: 1 },
            { sku: partNumber, quantity: 1 }
          ]
        })
      )
      const calculateBasketJsonData = yield call(fetchApi, calculateBasketEndpoint, { data: queryData })
      data.specialOfferPrice = calculateBasketJsonData
      data.specialOfferText =
        specialOffer.attributes?.shortDescription && decodeHTMLEntities(specialOffer.attributes?.shortDescription)
    }
    const successAction = fetchExtraDataSuccess(data)
    yield put(successAction)
  } catch (error) {
    const response = {
      errorDetail: error.toString(),
      errorCode: error.status || 500,
      data: {
        productId: partNumber
      }
    }
    if (error.response && error.response.body && error.response.body.errors) {
      response.errorDetail = error.response.body.errors
    }
    if (error.status === 404) {
      logger.error(
        'apiLogger',
        { arguments: [error.status, error.message, error.productId], error },
        'essentialExtrasDataSaga 404 Error'
      )
      response.data.productName = 'Product not found'
    } else {
      logger.error(
        'apiLogger',
        { arguments: [error.status, error.message, error.productId], error },
        `essentialExtrasDataSaga ${error.status || 500} Error`
      )
    }

    const failureAction = fetchExtraDataFailure(response)
    yield put(failureAction)
  }
}

export { essentialExtrasDataSaga, endpoint }
